import React, { useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postTasks } from "../../../../MyApi/crm/tasks";

import PageHeader from "../../../../Components/UI/PageHeader";
import AddTask from "../../../../Components/crm/Tasks/tasksStore/AddTask";

const TasksStore = () => {
  const [name, setName] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [repeat, setRepeat] = useState(0);
  const [repeat_period, setRepeatPeriod] = useState("");
  const [last_repeat_date, setLastRepeatPeriod] = useState("");
  const [crm_client_id, setCrmClientId] = useState("");
  const [crm_project_id, setCrmProjectId] = useState("");
  const [active, setActive] = useState(1);
  const [sb_branch_id, setBranchId] = useState("");
  const [sb_company_id, setCompanyId] = useState("");
  const [admin, setAdmin] = useState([]);
  const [moderator, setModerator] = useState([]);
  const [employes, setEmploye] = useState([]);
  const [listRow, setRows] = useState([{ id: 0 }]);
  const [lists, setLists] = useState({});

  const mutation = useMutation("postTasks", (postData) => postTasks(postData), {
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      setName("")
      setStartDate("")
      setEndDate("")
      setRepeatPeriod("")
      setLastRepeatPeriod("")
      setAdmin([])
      setModerator([])
      setEmploye([])
      setRows([{id:0}])
      setLists({})
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  let listArr = [];
  Object.values(lists).forEach((item) => {
    if (item !== null) {
      listArr.push(item);
    }
  });

  const handlePostRequest = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("sb_company_id", sb_company_id);
    formData.append("sb_branch_id", sb_branch_id);
    formData.append("start_date", start_date);
    formData.append("end_date", end_date);
    formData.append("repeat", repeat);
    formData.append("repeat_period", repeat_period);
    formData.append("last_repeat_date", last_repeat_date);
    formData.append("crm_client_id", crm_client_id);
    formData.append("active", active);
    formData.append("admin", JSON.stringify(admin));
    formData.append("moderator", JSON.stringify(moderator) );
    formData.append("employes", JSON.stringify(employes));

    listArr.forEach((item, indexList) => {
      formData.append(`lists[${indexList}][name] `, item.name);
      formData.append(`lists[${indexList}][description] `, item.description);

      if (item.attachements !== null) {
        item.attachements.forEach((attach, i) => {
          formData.append(
            `lists[${indexList}][attachements][0][name]`,
            attach.file
          );
          formData.append(
            `lists[${indexList}][attachements][0][file]`,
            attach.file
          );
        });
      } else {
        formData.append(`lists[${indexList}][attachements]`, null);
      }
    });

    mutation.mutate(formData);
  };
  const isDisabled = () => {
    return !(
      name &&
      sb_branch_id &&
      sb_company_id &&
      start_date &&
      end_date &&
      (repeat === 1 ? repeat_period && last_repeat_date : true) &&
      admin &&
      moderator &&
      employes &&
      lists
    );
  };
  const addRow = () => {
    setRows([...listRow, { id: listRow.length + 1 }]);
  };
  const removeRow = (RowId) => {
    setRows(listRow.filter((row) => row.id !== RowId));
    setLists({ ...lists, [RowId]: null });
  };
  return (
    <div>
      <PageHeader
        title="Add Task"
        showBack={true}
        saveButton={true}
        isLoading={mutation.isLoading}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <AddTask
        companyId={sb_company_id}
        branchId={sb_branch_id}
        repeat={repeat}
        active={active}
        setActive={setActive}
        name={name}
        end_date={end_date}
        start_date={start_date}
        removeRow={removeRow}
        listRow={listRow}
        addRow={addRow}
        lists={lists}
        setLists={setLists}
        setEmploye={setEmploye}
        setModerator={setModerator}
        setBranchId={setBranchId}
        setAdmin={setAdmin}
        setName={setName}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setRepeat={setRepeat}
        setRepeatPeriod={setRepeatPeriod}
        setLastRepeatPeriod={setLastRepeatPeriod}
        setCrmClientId={setCrmClientId}
        setCrmProjectId={setCrmProjectId}
        setCompanyId={setCompanyId}
      />
    </div>
  );
};

export default TasksStore;
